module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control-static"
  }, [_c('router-link', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "to": _vm.to
    }
  }, [_vm._v(_vm._s(_vm.link.label))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5004404b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/Fields/f-link.vue
// module id = 521
// module chunks = 55